// bbakery SITE BUILD BY COOPA
console.log('B-Bakery start');

jQuery(document).ready(function(){

	if ( typeof $.fn.slick === "undefined" ) {
		$.getScript("/assets/js/slick.min.js", function() {
		   initializeJs();
		});
	} else {
		initializeJs();
	}

});

function initializeJs() {

	// Get all "navbar-burger" elements
	var $navbarBurgers = Array.prototype.slice.call(document.querySelectorAll('.navbar-burger'), 0);

	// Check if there are any navbar burgers
	if ($navbarBurgers.length > 0) {

		// Add a click event on each of them
		$navbarBurgers.forEach(function ($el) {
			$el.addEventListener('click', function () {

				// Get the target from the "data-target" attribute
				var target = $el.dataset.target;
				var $target = document.getElementById(target);

				// Toggle the class on both the "navbar-burger" and the "navbar-menu"
				$el.classList.toggle('is-active');
				$target.classList.toggle('is-active');

				$('#primary-menu').css('min-height', '0');
				$('#primary-menu').removeClass('submenu-active');
				$('.has-dropdown.is-active').removeClass('is-active');

				// reset subnav
				$('#primary-menu > .navbar-menu').removeClass('submenu-active');
				$('.has-dropdown.is-active').removeClass('is-active');
				$('#primary-menu > .navbar-menu').css('min-height', '0');

			});
		});
	}

	// Submenu items on mobile

	var $haveDropdowns = $('.navbar-item.has-dropdown');
	var $closeSubmenu = $('.close-submenu');

	$haveDropdowns.each( function() {

		$(this).on('click', function (e) {

			// If the span is clicked then expand the menu on mobile

			if ( e.target.tagName.toLowerCase() == 'span' ) {

				e.stopPropagation();
				e.preventDefault();

				$('.has-dropdown.is-active').removeClass('is-active');
				$(this).addClass('is-active');

				$('#primary-menu > .navbar-menu').addClass('submenu-active');

				$('#primary-menu > .navbar-menu').css('min-height', $(this).find('.navbar-dropdown').outerHeight());
			}

		});

	});

	
	$closeSubmenu.on('click', function () {
		$('#primary-menu > .navbar-menu').removeClass('submenu-active');
		$('.has-dropdown.is-active').removeClass('is-active');
		$('#primary-menu > .navbar-menu').css('min-height', '0');
	});


	// Slick carousels

	if ( $('.article-list-slick').length > 0 ) {

		$('.article-list-slick').each( function() {

			var cards = $(this).find('article.js-experience-card').length;
			var initial_slide = 0;

			if ( cards && cards > 3 ) {
				initial_slide = 1;
			}

			$(this).slick({
				centerMode: true,
				centerPadding: '300px',
				slidesToShow: 3,
				initialSlide: initial_slide,
				dots: true,
				responsive: [{

					  breakpoint: 1024,
					  settings: {
						slidesToShow: 2,
						centerMode: true,
						centerPadding: '300px',
						initialSlide: initial_slide,
						dots: true,
					  }

					}, {

					  breakpoint: 768,
					  settings: {
						slidesToShow: 1,
						centerMode: true,
						centerPadding: '300px',
						dots: true,
					  }

					}
				]
			});
		}); 
		
	}

	

	if ( $('.feature-slides-slick').length > 0 ) {
		$('.feature-slides-slick').slick({
	        infinite: true,
			slidesToShow: 1,
			dots: true
		});
	}

	if ( $('.testimonial-slides-slick').length > 0 ) {
		$('.testimonial-slides-slick').slick({
	        infinite: true,
			slidesToShow: 1,
			dots: true
		});
	}

	if ( $('.images-slides-slick').length > 0 ) {
		$('.images-slides-slick').slick({
	        infinite: true,
	        centerMode: false,
			slidesToShow: 3,
			dots: false,
			responsive: [{

				  breakpoint: 1024,
				  settings: {
					slidesToShow: 3,
					centerMode: true,
					dots: false,
				  }

				}, {

				  breakpoint: 768,
				  settings: {
					slidesToShow: 1,
					centerMode: true,
					dots: false,
				  }

				}
			]
		});
	}
	
	// FAQ toggles
	$('body').on('click','.js-toggle-content',function(e){
		e.preventDefault();
		var $target = $(this).data('target');
		$(this).toggleClass('is-active');
		$('#'+$target).slideToggle();
	});

	$('body').on('click','.js-no-link',function(e){
		e.preventDefault();
	});

	$('body').on('click','.js-filter-posts',function(e){
		e.preventDefault();
		var $show = $(this).data('filter');
		$('.js-filter-posts.is-active').removeClass('is-active');
		$(this).addClass('is-active');			
		$('.js-experience-card').fadeOut();
		$('.js-experience-card').each(function(){
			var $filter = $(this).data('filter-set');			
			if( $filter.includes($show) ){
				$(this).fadeIn();
			}
		});
	});

	// default to first month on filter------------------------------
	if($('body .month-filter').length){
		$('body .month-filter a').first().trigger('click');
	}
	//---------------------------------------------------------------

	$('body').on('change','.js-private-hire-filter',function(e){
		var $show = $(this).val();
		$('.js-experience-card').fadeOut();
		$('.js-experience-card').each(function(){
			var $filter = $(this).data('filter-set');			
			if( $filter.includes($show) ){
				$(this).fadeIn();
			}
		});
	});


	//---------------------------------------------------------------
	// smoothscroll 
	$(document).on('click', 'a[href^="#"]', function (event) {
		event.preventDefault();
		$('html, body').animate({
			scrollTop: $($.attr(this, 'href')).offset().top
		}, 500);
	});


	//---------------------------------------------------------------
	// detect scrolled
	$(window).scroll(function (event) {
		var scroll_pos = $(window).scrollTop();
		// console.log('scroll_pos'+scroll_pos);
		if(scroll_pos>10){
			$('body').addClass('scrolled');
		}else{
			$('body').removeClass('scrolled');
		}
	});


	//---------------------------------------------------------------
	// contact form stuff
	// $('body').on('change','.js-change-form input',function(e){
		// if($(this).prop('checked')){
			// var show = window.enquiryTypeShowTextBox[$(this).data('index')];
			// if(show){
				// $('.form-group.field-contactform-people').closest('.field-body').slideUp();
			// }else{
				// $('.form-group.field-contactform-people').closest('.field-body').slideDown();
				// $('.form-group.field-contactform-people').slideDown();
				// $('.form-group.field-contactform-date').slideDown();
			// }
		// }
	// });
	// $('body .js-change-form').trigger('click');

	//---------------------------------------------------------------
	// contact form stuff
	// $('body').on('change','.js-changer input',function(e){
	$('body').on('change', '.js-changer input', function(e) {
        // console.log("Radio changed after timeout:", this);
        if ($(this).prop('checked')) {
            // alert($(this).data('peeps'));
            var show = $(this).data('peeps');
            // alert(show);
            if (show) {
            	$('.field-body.people').slideDown();                
            } else {
            	$('.field-body.people').slideUp();                
            }
        }
	});



	//---------------------------------------------------------------
	// new slider arrows	
	$(window).resize(function() { bb_slidrez(); }); 	
	$('body').on('click','.bb-new-prev',function(e){
		e.preventDefault();
		bb_slidgo($(this),'prev');
	});
	$('body').on('click','.bb-new-next',function(e){
		e.preventDefault();
		bb_slidgo($(this),'next');
	});
	function bb_slidgo(el,direction){
		$(el).siblings().find('.slick-'+direction).trigger('click');
	}
	function bb_slidrez(){
		var $doc = $(window).width();
		var $slid = $('.slider-container').first().width();
		var $w = (($doc - $slid)/2) ;
		$('.bb-new-next').css('width',$w+'px');
		$('.bb-new-next').css('margin-right',-$w+'px');
		$('.bb-new-prev').css('width',$w+'px');
		$('.bb-new-prev').css('margin-left',-$w+'px');
		$('.bb-new-prev').siblings().find('.slick-arrow').css('opacity',0);
	}
	bb_slidrez();
	//---------------------------------------------------------------


	
	$(window).resize(function() { bb_check_resize(); }); 	
	function bb_check_resize(){
		if($('#floating_book_now').length){
			var button 		= '#book_now';
			var floatbutton	= '#floating_book_now';
			var innerheight = window.innerHeight;
			var width 		= $(button).width();
			var height 		= $(button).height();
			var left  		= $(button)[0].getBoundingClientRect().left + $(window)['scrollLeft']();
			$(floatbutton).css('left',(left)+'px');
			$(floatbutton).css('width',width+'px');
			$(floatbutton).css('top',innerheight-height);
			$(floatbutton).css('position','fixed');
			bb_check_scroll();			
		}
	}
	bb_check_resize();


	$(window).scroll(function() { bb_check_scroll(); });
	function bb_check_scroll(){
		if($('#floating_book_now').length){
			var button 		= '#book_now';
			var floatbutton	= '#floating_book_now';
			var innerheight = window.innerHeight;
			var height 		= $('#book_now').height();
			var scrolltop 	= $(window)['scrollTop']();
			var toppos 		= $('#book_now')[0].getBoundingClientRect().top;
			var calc 		= ((innerheight-height) > (toppos+100));
			$(floatbutton).css('transition','all .5s');
			if(calc){
				$(floatbutton).css('opacity','1');
				$(floatbutton).css('transform','translateY(0px)');
				// $(button).css('visibility','hidden')
			}else{
				$(floatbutton).css('opacity','0');
				$(floatbutton).css('transform','translateY(50px)');
				// $(button).css('visibility','visible')
			}

		}
	}
	bb_check_scroll();

	
	$('#blog-filter').on('change', function() {

		var url = $('#blog-filter option:selected').val(); 

        if (url) { 
            window.location = url; 
        }
        
        return false;
	});

	$('.js-video-play').on('click', function(e) {

		e.preventDefault();
		var $container = $(this).parent();
		var $vid = $(this).data('id');
//		$container.find('iframe').attr('src', $container.find('iframe').fadeIn().attr('src') + '?autoplay=1');
		$container.find('.video-thumb, .video-play').fadeOut( function() {
			$container.find('iframe').fadeIn();
		});
		setTimeout("do_player_"+($vid.replace('-','_'))+"()",2);

	});


	// ================================================================================================
	// pop up mailing list
	// ================================================================================================
	$('.js-mailing-list-form').on('submit',function(e){
		e.preventDefault();
		var email = $('#mailing_list_signup_email').val();
		$.getScript('//s3.amazonaws.com/downloads.mailchimp.com/js/mc-validate.js');
		window.fnames = new Array(); 
		window.ftypes = new Array();
		fnames[0]='EMAIL';
		ftypes[0]='email';
		fnames[1]='FNAME';
		ftypes[1]='text';
		fnames[3]='MMERGE3';
		ftypes[3]='text';
		fnames[2]='MMERGE2';
		ftypes[2]='date';
		fnames[4]='MMERGE4';
		ftypes[4]='text';
		// var $mcj = jQuery.noConflict(true);</script>
		// 
		if(email.length>0) $('.mailing-list-popup-container').fadeIn();
		$('.js-email-address').val(email);
	});
	$('.js-mailing-list-popup-close').on('click',function(e){
		e.preventDefault();
		$('.mailing-list-popup-container').fadeOut();
	});


	// ================================================================================================
	// cookies
	// ================================================================================================
	if (getCookie('cookie_notice')!='accept'){	
		setTimeout("$('.cookie-notice').fadeIn();",200);
	}
	$('.cookie-notice-button-accept-cookie').on('click',function(e){
		e.preventDefault();
		$('.cookie-notice').fadeOut();
		setCookie('cookie_notice', 'accept'); 
	});
	

	// ================================================================================================
	// pop up banners
	// ================================================================================================
	var popup_id = $('.popup-container').prop('id');
	//console.log('popup_id'+popup_id);
	$('.js-popup-close').on('click',function(e){
		e.preventDefault();
		$('.popup-container').fadeOut();
	    setCookie('hide_popup', popup_id); 
	});

	if (getCookie('hide_popup') != popup_id){	
		if(typeof($('.popup-container'))!="undefined"){
			// $('.popup-container').fadeIn();
			setTimeout("$('.popup-container').fadeIn();",3000);
		}
	}



	// ================================================================================================
	function setCookie (name, value, expires, path, domain, secure) {
	    document.cookie = name + "=" + escape(value) +
	    ((expires) ? "; expires=" + expires : "") +
	    ((path) ? "; path=" + path : "") +
	    ((domain) ? "; domain=" + domain : "") +
	    ((secure) ? "; secure" : "");
	}
	// ================================================================================================
	function getCookie (name) {
	    var cookie = " " + document.cookie;
	    var search = " " + name + "=";
	    var setStr = null;
	    var offset = 0;
	    var end = 0;
	    if (cookie.length > 0) {
	        offset = cookie.indexOf(search);
	        if (offset != -1) {
	            offset += search.length;
	            end = cookie.indexOf(";", offset);
	            if (end == -1) {
	                end = cookie.length;
	            }
	            setStr = unescape(cookie.substring(offset, end));
	        }
	    }
	    if (setStr == 'false') {
	        setStr = false;
	    } 
	    if (setStr == 'true') {
	        setStr = true;
	    }
	    if (setStr == 'null') {
	        setStr = null;
	    }
	    return(setStr);
	}	

	// ================================================================================================
	// masonry for css grid

	function resizeGridItem(item){
	   grid = document.getElementsByClassName("images-grid")[0];
	   rowHeight = parseInt(window.getComputedStyle(grid).getPropertyValue('grid-auto-rows'));
	   rowGap = parseInt(window.getComputedStyle(grid).getPropertyValue('grid-row-gap'));
	   rowSpan = Math.ceil((item.querySelector('img').getBoundingClientRect().height+rowGap)/(rowHeight+rowGap));
	   item.style.gridRowEnd = "span "+rowSpan;
	}

	//not so good at making names
	function resizeAllGridItems(){
	   allItems = document.getElementsByClassName("images-grid-image");
	   for(x=0;x<allItems.length;x++){
	      resizeGridItem(allItems[x]);
	   }
	}

	setTimeout(resizeAllGridItems(), 500);
	setTimeout(resizeAllGridItems(), 1000);
	window.addEventListener("resize", resizeAllGridItems);


	// ================================================================================================
	// lazyload
	lazyload();

	// ================================================================================================
	// video containers within copy
	// ================================================================================================
	$('article.article iframe').wrap('<div class="video-responsive-in-content"></div>');

}
